export const SET_ACTIVE_WIDGET = 'SET_ACTIVE_WIDGET';
export const SET_DRAGGED_WIDGET = 'SET_DRAGGED_WIDGET';
export const SET_LAYOUT = 'SET_LAYOUT';
